export default "__VITE_ASSET__D31KIaXu__"